import React from 'react';
import { Button } from 'react-bootstrap';
import './CustomButton.scss';

const CustomButton = (props) => {
    let { title, iconClass, type, className, onClick, disabled } = props
    return (
        <Button
            className={className}
            type={type}
            onClick={onClick}
            disabled={disabled}>{title}
            {props.iconShow &&
                <i className={"icon-css " + iconClass}></i>
            }
        </Button>
    )
}

CustomButton.defaultProps = {
    className: 'submitBtn',
};

export default CustomButton;

